import { Application, merge } from '@serviceos-rn/core';
import { TipConfig } from './TipConfig';
import { LIB_VERSION } from '../version';
import { TipProviderFactory } from './TipProviderFactory';
import { RootScreenComponent } from './Presentation/Screens/RootScreen/RootScreenComponent';
export const TipModuleComponentFactory = {
    version: LIB_VERSION,
    create(initParams = {}) {
        Application.update(TipConfig.moduleName, merge({}, initParams));
        Application.providers.setProvider(TipConfig.provider, {
            factory: () => TipProviderFactory.create(initParams.payload)
        });
        return RootScreenComponent;
    }
};
